import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/close-button-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-d3004272"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = {
  class: "modal__window",
  role: "dialog"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (_ctx.openModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "modal__overlay",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', false)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "modal__close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close', false)))
              }, _hoisted_4),
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.title), 1),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}